import NotFound from './not-found';

export default {
  component: NotFound,
  url: '*',
  exact: false,
};
